<template>
	<v-layout row wrap primary white--text class="section-use" id="sectionuse">
		<v-flex xs12 class="container">
			<v-layout wrap>
				<v-flex xs12 text-xs-center>
					<h2 class="section-use-title">¿CÓMO EMPEZAR A USAR MI APLICATIVO CASAMARKET?</h2>
					<p class="section-use-caption">Muy sencillo de usar</p>
				</v-flex>
				<v-flex xs12 md7 text-xs-center class="btn-container">
					<v-layout row wrap align-center justify-center>
						<v-flex xs6 sm3>
							<v-btn
								class="btn-action btn-auto section-use-btn active white--text"
								depressed
								@click="restoreAll"
							>
								Regístrate
							</v-btn>
						</v-flex>
						<v-flex xs6 sm3>
							<v-btn
								class="btn-action btn-auto section-use-btn"
								:class="customActive ? 'active white--text' : 'primary--text'"
								depressed
								@click="activeStep('customActive')"
							>
								Personaliza
							</v-btn>
						</v-flex>
						<v-flex xs6 sm3>
							<v-btn
								class="btn-action btn-auto section-use-btn"
								:class="shareActive ? 'active white--text' : 'primary--text'"
								depressed
								@click="activeStep('shareActive')"
							>
								Comparte
							</v-btn>
						</v-flex>
						<v-flex xs6 sm3>
							<v-btn
								class="btn-action btn-auto section-use-btn"
								:class="sellActive ? 'active white--text' : 'primary--text'"
								depressed
								@click="activeStep('sellActive')"
							>
								Vende
							</v-btn>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 class="card-container">
					<v-layout row wrap align-center white class="section-use-card">
						<v-flex xs12 md7>
							<h3 class="active-title primary--text">{{ active.title }}</h3>
							<template v-if="active.paragraphs">
								<template v-for="paragraph in active.paragraphs">
									<p :key="paragraph.id" class="active-paragraph info--text" v-html="paragraph.text"></p>
									<template v-if="paragraph.list">
										<template v-for="(item, index) in paragraph.list">
											<p :key="index" class="active-item info--text">
												<img
													src="/static/images/icons/icon-check-CM.svg"
													alt="viñeta para text"
													height="20"
													class="image-check"
												/>
												{{ item }}
											</p>
										</template>
									</template>
								</template>
							</template>
							<template v-if="active.span && active.text">
								<p class="active-text info--text">
									<span class="active-span secondary--text">{{ active.span }}</span>
									{{ active.text }}
								</p>
							</template>
						</v-flex>
						<v-flex xs12 md5 text-xs-center class="position-relative">
							<img :src="active.image" :alt="active.title" :class="`${active.class} image-absolute`"  height="592"/>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	function created() {
		this.active = this.items.find(item => item.code === 'registerActive');
	}

	function activeStep(step) {
		this[step] = true;
		this.active = this.items.find(item => item.code === step);
		if (step === 'customActive') {
			this.shareActive = false;
			this.sellActive = false;
		} else if (step === 'shareActive') {
			this.customActive = true;
			this.sellActive = false;
		} else {
			this.customActive = true;
			this.shareActive = true;
		}
	}

	function restoreAll() {
		this.active = this.items.find(item => item.code === 'registerActive');
		this.customActive = false;
		this.shareActive = false;
		this.sellActive = false;
	}

	function data() {
		return {
			active: {
				paragraphs: [],
			},
			items: [
				{
					id: 1,
					code: 'registerActive',
					image: '/static/images/sections/feature-1.png',
					title: 'Regístrate',
					paragraphs: [
						{
							id: 1,
							text: 'Inscríbete en <a href="https://www.casamarket.la" target="_blank">casamarket.la</a> y uno de nuestros asesores se comunicará contigo para hacerte una presentación detallada de servicio.',
						},
						{
							id: 2,
							text: 'Al registrarte nos ayudas a que nos comuniquemos contigo y validemos tu información.Además, te mantendremos informados sobre mejoras y actualizaciones de tu app.',
						},
					],
				},
				{
					id: 2,
					code: 'customActive',
					image: '/static/images/sections/use-2.png',
					title: 'Personaliza',
					paragraphs: [
						{
							id: 1,
							text: '¿CÓMO EMPEZAR A USAR MI CASAMARKET?  Tu app es muy amigable y fácil de usar.',
						},
						{
							id: 2,
							text: 'Personaliza tu aplicativo.',
							list: [
								'Logo',
								'Imágenes de producto',
								'Banners promocionales',
							],
						},
						{
							id: 3,
							text: 'No te preocupes si no tienes idea de cómo hacerlo, nosotros te asesoramos.',
						},
					],
				},
				{
					id: 3,
					code: 'shareActive',
					image: '/static/images/sections/use-3.png',
					title: 'Comparte',
					paragraphs: [
						{
							id: 1,
							text: '¿CÓMO EMPEZAR A USAR CASAMARKET?  Tu app es muy amigable y fácil de usar.',
						},
						{
							id: 2,
							text: 'Podrás decirle a tus clientes que se descarguen tu app.Comienza a generar pedidos con tu app.',
						},
						{
							id: 3,
							text: 'Te ayudamos a compartir tu app con:',
							list: [
								'PlaySorte',
								'Link generado',
								'Código QR',
							],
						},
					],
				},
				{
					id: 4,
					code: 'sellActive',
					image: '/static/images/sections/use-4.png',
					title: 'Vende',
					span: 'LISTO:',
					text: 'INCREMENTA TUS VENTAS. RECIBIR Y ATENDER PEDIDOS ES MUY SENCILLO',
					paragraphs: [
						{
							id: 1,
							text: '¿CÓMO EMPEZAR A USAR MI CASAMARKET?  Tu app es muy amigable y fácil de usar',
						},
					],
				},
			],
			customActive: false,
			registerActive: true,
			shareActive: false,
			sellActive: false,
		};
	}

	export default {
		name: 'section-how-to-user',
		created,
		data,
		methods: {
			activeStep,
			restoreAll,
		},
	};
</script>

<style lang="scss" scoped>
	.section-use {
		@media (min-width: 1400px) {
			padding: 0px 10%;
		}

		&-title {
			font-size: size(large30);
			font-weight: weight(w900);
			line-height: 1;
			padding: 50px 6% 22px;

			@media (min-width: 360px) {
				padding: 50px 13% 22px;
			}

			@media (min-width: 1024px) {
				padding: 50px 0 24px;
			}
		}

		&-caption {
			font-size: size(medium18);
		}

		&-btn {
			background-color: transparent !important;
			background-image: url('/static/images/icons/rectangle-CM.svg');
			background-position: center;
			background-repeat: no-repeat;
			background-size: auto;
			font-size: size(medium16);
			font-weight: weight(w600);
			height: 46px !important;
			margin-top: 23px;
			width: 135px !important;

			@media (min-width: 1024px) {
				background-size: cover;
				height: 37px !important;
				margin-top: 0px;
			}

			&.active {
				background-image: url('/static/images/icons/rectangle-active-CM.svg');
				font-weight: weight(w900);
			}
		}

		&-card {
			background-image: url('/static/images/banners/background-content.svg');
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
			border-radius: 18px;
			box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.5);
			margin-top: 22px;
			padding-bottom: 282px;

			@media (min-width: 1024px) {
				height: 389px;
				padding-bottom: 0px;
			}
		}
	}

	.btn-container {
		padding: 0px 9%;

		@media (min-width: 360px) {
			padding: 0px 7%;
		}

		@media (min-width: 1024px) {
			margin-top: 55px;
			padding: 0px 3%;
		}

		@media (min-width: 1280px) {
			padding: 0px 8%;
		}

		@media (min-width: 1400px) {
			padding: 0px 0px 0px 11%;
		}
	}

	.card-container {
		padding: 13px 2% 378px;

		@media (min-width: 360px) {
			padding: 13px 5% 345px;
		}

		@media (min-width: 768px) {
			padding: 13px 8% 345px;
		}

		@media (min-width: 1024px) {
			padding: 13px 8% 150px;
		}

		@media (min-width: 1280px) {
			padding: 13px 10% 150px;
		}
	}

	.image-absolute {
		left: 0;
		margin: auto;
		position: absolute;
		right: 0;

		@media (min-width: 1024px) {
			bottom: 0;
			top: 0;
		}
	}

	.position-relative {
		position: relative;
	}

	.active-title {
		font-size: size(large25);
		font-weight: weight(w900);
		padding: 62px 0px 33px;
		text-align: center;
		text-transform: uppercase;

		@media (min-width: 1024px) {
			padding: 0px 10% 24px;
			text-align: left;
		}
	}

	.active-paragraph {
		font-size: size(medium16);
		line-height: 1.4;
		padding: 0px 5% 15px;
		text-align: center;

		@media (min-width: 360px) {
			padding: 0px 8% 15px;
		}

		@media (min-width: 1024px) {
			padding: 0px 10% 10px;
			text-align: left;
		}
	}

	.active-item {
		font-size: size(medium16);
		margin: 0px auto 10px;
		max-width: 55%;

		@media (min-width: 1024px) {
			margin: 0px;
			max-width: none;
			padding: 0px 10% 10px;
		}
	}

	.image-check {
		margin-right: 10px;
	}

	.active-span {
		font-size: size(medium18);
		font-weight: weight(w800);

		@media (min-width: 1024px) {
			font-size: size(large26);
			font-weight: weight(w900);
		}
	}

	.active-text {
		font-size: size(medium18);
		font-weight: weight(w800);
		text-align: center;
		padding: 0px 6% 15px;

		@media (min-width: 360px) {
			padding: 0px 10% 15px;
		}

		@media (min-width: 1024px) {
			font-size: size(large23);
			font-weight: weight(w900);
			text-align: left;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-how-to-use.vue